module.exports = __webpack_public_path__ + "img/pcsetup.7b6790dd.png";